export default "__VITE_ASSET__enX1DyTI__"